import { useState } from 'react';

// a boolean map keyed by series label/index, with toggle(key) flipping one entry -
// the "hide this series" idiom shared by every chart's legend/pills
export function useToggleMap(initial = {}) {
    const [hidden, setHidden] = useState(initial);
    const toggle = (key) => setHidden(prev => ({ ...prev, [key]: !prev[key] }));
    return [hidden, toggle];
}
